import NotesLayout from '../components/layouts/NotesLayout.vue';
import NotesIndexPage from '../pages/NotesIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/notes',
        name: 'notes.root',
        component: NotesLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'notes.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /notes
                path: '',
                name: 'NotesIndexPage',
                component: NotesIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /notes/create
            //   name: 'notes.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
